import { render, staticRenderFns } from "./UserManagementDeleteButton.vue?vue&type=template&id=44998178&"
import script from "./UserManagementDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./UserManagementDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports